module.exports = __webpack_public_path__ + "img/40_38_034_140.bd057e7e.jpg";